import { useState } from 'react';
import { api } from '../api';
import type { UserSummary } from '../../shared/types';

export function LoginPage({onLogin}:{onLogin:(user:UserSummary)=>void}){
 const [username,setUsername]=useState('');const[password,setPassword]=useState('');const[error,setError]=useState('');const[busy,setBusy]=useState(false);
 async function submit(event:React.FormEvent){event.preventDefault();setBusy(true);setError('');try{onLogin((await api.login(username,password)).user)}catch(e){setError(e instanceof Error?e.message:'Anmeldung fehlgeschlagen.')}finally{setBusy(false)}}
 return <div className="login-page"><div className="login-card">
  <img className="login-logo" src="/assets/logo-lockup.svg" alt="MYY Content Studio"/>
  <div className="ornament"><img src="/assets/ornament-divider.svg"/></div>
  <h1>Willkommen zurück</h1><p>Melde dich mit deinem internen Project-MYY-Konto an.</p>
  <form onSubmit={submit}>
   <label>Benutzername<input autoComplete="username" value={username} onChange={e=>setUsername(e.target.value)} required/></label>
   <label>Passwort<input type="password" autoComplete="current-password" value={password} onChange={e=>setPassword(e.target.value)} required/></label>
   {error&&<div className="form-error">{error}</div>}
   <button className="button primary block" disabled={busy}>{busy?'Anmeldung läuft …':'Anmelden'}</button>
  </form><small className="login-foot">Nur für das Project-MYY-Team.</small>
 </div></div>
}
